// Opportunity API
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    OpportunityType,
} from 'app/Apps/AccountManagement/Opportunities/opportunities.types'

type Request = {
    domainName: string,
    GetOpportunityById: RequestConfigFunction<{ id: number }>,
    FilterRequest: RequestConfigFunction<{ params?: Record<string, any> }>,
    archive: RequestConfigFunction<{ id: number }>,
    restore: RequestConfigFunction<{ id: number }>,
    UpdateOpportunity: RequestConfigFunction<{ opportunityId: number }>,
    UpdateContainerInformation: RequestConfigFunction<{ opportunityId: number }>,
    CreateOpportunity: RequestConfigFunction<undefined>,
    modifications: RequestConfigFunction<{ id: number }>,
    bulkCreate: RequestConfigFunction<{ data?: OpportunityType[] }>,
    bulkEdit: RequestConfigFunction<{ data?: OpportunityType[] }>,
    spreadsheet: RequestConfigFunction<Record<string, any>>,
    filterSpreadsheetCount: RequestConfigFunction<{ fieldName: string }>,
    filterLanesRequest: RequestConfigFunction<{ id: number, params?: Record<string, any> }>,
    filterCountLanesRequest: ({
        id,
    }: {
        id: number,
    }) => {
        customUrl: string
    },
    opportunitiesByRegionalGroup: RequestConfigFunction<
        { id: number, params?: Record<string, any> }
    >,
    opportunitiesByRegionalGroupCountRequest: ({
        id,
    }: {
        id: number,
    }) => {
        customUrl: string
    },
}

const opportunityRequests: Request = {
    domainName: 'Opportunity',
    GetOpportunityById: ({
        id,
    }) => {
        return {
            url: `opportunity/${id}`,
            method: 'GET',
        }
    },
    UpdateOpportunity: ({
        opportunityId,
    }) => {
        return {
            url: `opportunity/${opportunityId}`,
            method: 'PUT',
        }
    },
    UpdateContainerInformation: ({
        opportunityId,
    }) => {
        return {
            url: `opportunity/${opportunityId}/container-info`,
            method: 'PATCH',
        }
    },
    CreateOpportunity: () => {
        return {
            url: 'opportunity',
            method: 'POST',
        }
    },
    FilterRequest: ({
        params,
    }) => {
        return {
            url: 'opportunity/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `opportunity/${id}/modifications`,
            method: 'GET',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `opportunity/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `opportunity/${id}/restore`,
            method: 'PATCH',
        }
    },
    bulkCreate: ({
        data,
    } = {}) => {
        return {
            url: 'opportunity/bulk',
            method: 'POST',
            data,
        }
    },
    bulkEdit: ({
        data,
    } = {}) => {
        return {
            url: 'opportunity/bulk',
            method: 'PATCH',
            data,
        }
    },
    spreadsheet: (data) => {
        return {
            url: 'opportunity/filter-request/spreadsheet',
            method: 'POST',
            ...data,
        }
    },
    filterSpreadsheetCount: ({
        fieldName,
    }) => {
        return {
            url: `opportunity/filter-request/spreadsheet/count/${fieldName}`,
            method: 'POST',
        }
    },
    filterLanesRequest: ({
        id,
        params,
    }) => {
        return {
            url: `opportunity/${id}/lane/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    filterCountLanesRequest: ({
        id,
    }) => {
        return {
            customUrl: `opportunity/${id}/lane/filter-request/all`,
        }
    },
    opportunitiesByRegionalGroup: ({
        id,
        params,
    }) => {
        return {
            url: `opportunity/regionalgroup/${id}/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    opportunitiesByRegionalGroupCountRequest: ({
        id,
    }) => {
        return {
            customUrl: `opportunity/regionalgroup/${id}/filter-request/all`,
        }
    },
}

export default opportunityRequests
